import { type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  exportQuickBooksOnlineData: "QuickBooks.ExportQuickBooksOnlineData",
};

export { names as quickBooksRouteNames };

const quickBooksRoutes: RouterOptions["routes"] = [
  {
    path: "/quickBooks",
    component: () => import("@/views/quickBooks/QuickBooksBase.vue"),
    children: [
      {
        path: "exportQuickBooksOnlineData",
        name: names.exportQuickBooksOnlineData,
        meta: { title: "QuickBooks Online Data Export", hideFilterChange: true },
        component: () => import("@/views/quickBooks/QuickBooksOnlineDataExport.vue"),
      },
    ],
  },
];
export default quickBooksRoutes;
